//import jquery from 'jquery';
//import './assets/bootstrap/bootstrap.js';
//import 'tether';
import 'mobile-detect';

import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locale'
import VueMoment from 'vue-moment'
import ElementUI from 'element-ui';
import '../theme/index.css'
//import numFormat from 'vue-filter-number-format';
import Vue2Filters from 'vue2-filters'

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard);

Vue.use(Vue2Filters);

import 'normalize.css' // normalize
import './assets/material-design-icons/material-design-icons.css';
import './assets/font-awesome/css/font-awesome.css';
//import './assets/bootstrap/bootstrap.css';
//import './assets/app.css';
import './assets/font.css';
import 'flag-icon-css/css/flag-icon.css';

//Vue.filter('numFormat', numFormat);

Vue.use(ElementUI);

//Vue.prototype.$jquery = jquery;

Vue.config.productionTip = false;

Vue.use(VueMoment);

// Vue.filter('n', function (value, fractionDigits) {
//     value = new Intl.NumberFormat(false, { minimumFractionDigits: fractionDigits || 0, maximumFractionDigits: fractionDigits || 0}).format(value);
//     return value.replace(",",".");
// });

Vue.filter('n', function (value, maximumFractionDigits, symbol) {
    value = new Intl.NumberFormat(false, { maximumFractionDigits: maximumFractionDigits || 2}).format(value);
    if (symbol) return value.replace(",",".") + ' ' + symbol;
    return value.replace(",",".");
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
